/**
 * Universal indicator mapper: converts any format to flat DB schema
 * Supports both UI format { type, settings } and flat format { key, period }
 */
export function mapIndicatorToDB(ind: any): Record<string, any> {
  if (!ind) return { key: 'custom' };

  const type = ind.type || ind.key;

  switch (type) {
    case 'sma':
      return {
        key: 'sma',
        period: ind.settings?.period ?? ind.period ?? 20,
        ...(ind.overbought !== undefined && { overbought: ind.overbought }),
        ...(ind.oversold !== undefined && { oversold: ind.oversold })
      };

    case 'ema':
      return {
        key: 'ema',
        period: ind.settings?.period ?? ind.period ?? 20,
        ...(ind.overbought !== undefined && { overbought: ind.overbought }),
        ...(ind.oversold !== undefined && { oversold: ind.oversold })
      };

    case 'macd':
      return {
        key: 'macd',
        fast: ind.settings?.fastPeriod ?? ind.fast ?? 12,
        slow: ind.settings?.slowPeriod ?? ind.slow ?? 26,
        signal: ind.settings?.signalPeriod ?? ind.signal ?? 9
      };

    case 'adx':
      return {
        key: 'adx',
        period: ind.settings?.period ?? ind.period ?? 14,
        trendStrength: ind.settings?.trendStrength ?? ind.trendStrength ?? 25
      };

    case 'rsi':
      return {
        key: 'rsi',
        period: ind.settings?.period ?? ind.period ?? 14,
        overbought: ind.settings?.overbought ?? ind.overbought ?? 70,
        oversold: ind.settings?.oversold ?? ind.oversold ?? 30
      };

    case 'bb':
    case 'bollingerbands':
      return {
        key: type === 'bollingerbands' ? 'bollingerbands' : 'bb',
        period: ind.settings?.period ?? ind.period ?? 20,
        std: ind.settings?.std ?? ind.std ?? 2
      };

    case 'stochastic':
      return {
        key: 'stochastic',
        k: ind.settings?.kPeriod ?? ind.k ?? 14,
        d: ind.settings?.dPeriod ?? ind.d ?? 3,
        smooth: ind.settings?.smoothPeriod ?? ind.smooth ?? 3
      };

    case 'momentum':
      return {
        key: 'momentum',
        period: ind.settings?.period ?? ind.period ?? 14
      };

    default:
      return { key: String(type || 'custom') };
  }
}

/**
 * Maps array of indicators to DB format
 */
export function mapIndicatorsArrayToDB(indicators: any[]): any[] {
  if (!Array.isArray(indicators)) return [];
  return indicators.map(mapIndicatorToDB);
}
